import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const ProjectCard = ({ project }) => {

  const convertStartDate = (startDate) => {
    const startDateObj = new Date(startDate);
    const now = new Date();
    // 開始日を過ぎている場合は即日表示とする
    if (startDateObj.valueOf() < now.valueOf()) {
      return '即日';
    } else {
      return startDateObj.toLocaleDateString()
    };
  }

  return <Card
    style={{
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      borderRadius: '0', // 角丸をなくす
      boxShadow: 'none', // 影をなくす
      borderBottom: '1px solid #ccc', // 下線のみのボーダーにする
      margin: '0',
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#F5F5F5')}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
  >
    {/* <CardContent>
      <Typography
        variant="body2"
        component="div"
        style={{ fontSize: '1.1rem', color: '#1D55B5', fontWeight: 'bold' }} // 文字サイズと色を変更
      >
        {project.title}
      </Typography>
      <Typography
        variant="body2"
        style={{ fontSize: '1rem', color: '#666' }} // 文字サイズと色を変更
      >
        {project.reward}　{new Date(project.start_date).toLocaleDateString()}　{project.work_style}
      </Typography>
      <Typography
        variant="body2"
        style={{ fontSize: '1rem', color: '#666' }} // 文字サイズと色を変更
      >
        {project.tag}
      </Typography>
    </CardContent> */}
    <div className='project-card-content' style={{ padding: '16px' }}>
      <p className="project-title" style={{ fontSize: '1.1rem', color: '#1D55B5', fontWeight: 'bold' }}>{project.title}</p>
      <div className='project-details'>
        <p className="project-reward" style={{ fontSize: '1rem', color: '#666' }}>{project.reward}</p>
        <p className="project-start-date" style={{ fontSize: '1rem', color: '#666' }} >{convertStartDate(project.start_date)}</p>
        <p className="project-work-style" style={{ fontSize: '1rem', color: '#666' }} >{project.work_style}</p>
      </div>
      {
        project.tag.split(',').map((tag) => (
          <p className="project-tag" style={{ fontSize: '1rem', color: '#666' }} >{tag}</p>
        ))
      }
    </div>
  </Card>;
}

export default ProjectCard;

